module.exports = __webpack_public_path__ + "static/quiz_question_girl_boy_false_bg-aa184dbbfd1a43187091bc42680c794f.svg";